'use strict';

angular.module('programme')

.service('hyperlinkEditModal', function ($uibModal)
{
    this.open = function ()
    {
        return $uibModal.open({
            size: 'sm',
            templateUrl: 'modules/programme/editor-components/link/hyperlinkEditModal.html',
            replace: false,
            controller: 'hyperlinkEditModalCtrl',
            windowClass: 'link-modal',
        });
    };
});
